import { createContext, useContext } from 'react';

import type { Links } from 'bundles/megamenu/constants/simplifiedMegaMenuContent';

type MegaMenuLinksContextValue = {
  links: Links;
  isEnterprise: boolean;
};

const MegaMenuLinksContext = createContext<MegaMenuLinksContextValue | undefined>(undefined);

export const useMegaMenuLinks = () => {
  return useContext(MegaMenuLinksContext);
};

export default MegaMenuLinksContext;
